import React from 'react';
import Popup from 'reactjs-popup';
import './status-tag.scss';
import { ProductSegmentMetric } from '@zonofi/zono-money-store';

interface StatusTagProps {
  mainText: string;
  background: string;
  color: string;
}

export const StatusTag: React.FC<StatusTagProps> = ({
  mainText,
  background,
  color,
}) => {
  return (
    <div
      style={{
        backgroundColor: background,
        borderColor: 'transparent',
        borderRadius: 3,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: 17,
      }}
      className="font-primary"
    >
      <span
        style={{
          color: color,
          fontSize: 12,
          lineHeight: 25,
        }}
      >
        {mainText}
      </span>
    </div>
  );
};

const getProductSegmentStyle = (
  metric: ProductSegmentMetric
): { background: string; color: string; emoji: string } => {
  switch (metric) {
    case ProductSegmentMetric.FAST_MOVING:
      return { background: '#F0A997', color: '#000', emoji: '⚡' };
    case ProductSegmentMetric.NEW_LAUNCH:
      return { background: '#A3E2C8', color: '#000', emoji: '🚀' };
    case ProductSegmentMetric.TOP_GROSSING:
      return { background: '#CEABFF', color: '#000', emoji: '🏆' };
    case ProductSegmentMetric.NON_MOVING:
      return { background: '#D9D9D9', color: '#000', emoji: '⏸️' };
    case ProductSegmentMetric.SLOW_MOVING:
      return { background: '#91BEFF', color: '#000', emoji: '😴' };
    default:
      return { background: '#E0E0E0', color: '#000', emoji: '' };
  }
};

export const SegmentTag: React.FC<{ mainText: ProductSegmentMetric }> = ({
  mainText,
}) => {
  const { background, color, emoji } = getProductSegmentStyle(mainText);
  return (
    <div
      className="status-tag-product-segment-tag"
      style={{
        backgroundColor: background,
      }}
    >
      <span
        style={{
          color: color,
        }}
        className="font-primary "
      >
        {emoji} {mainText}
      </span>
    </div>
  );
};

export const SegmentTagsPopup: React.FC<{
  tags: { segmentName: ProductSegmentMetric; segmentId: string }[];
}> = ({ tags }) => {
  return (
    <Popup
      trigger={
        <div
          className="more-chip-tags-count font-primary"
          style={{ zIndex: 99999999 }}
        >
          {`+ ${tags.length}`}
        </div>
      }
      on={['hover']}
      closeOnEscape
      arrow={false}
      position="bottom left"
    >
      <div
        className="more-chip-tags-popup"
        style={{ width: 'auto', minWidth: '80px' }}
      >
        {tags.map((tag, index) => (
          <SegmentTag key={index} mainText={tag.segmentName} />
        ))}
      </div>
    </Popup>
  );
};
